import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Motivo de Estorno',
  path: '/merenda/mermotivoestorno',
  name: 'mermotivoestorno',
  component: () => import('@/views/merenda/mermotivoestorno/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MOTIVOESTORNONOVO_MENU_1900500650],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Motivo de Estorno',
  path: '/merenda/mermotivoestorno/cadastro/:id?',
  parent: 'mermotivoestorno',
  name: 'mermotivoestorno_create',
  component: () => import('@/views/merenda/mermotivoestorno/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.MOTIVOESTORNONOVO_MENU_1900500650],
  },
  goesToMenu: true,
 },
]
